export const USER_PRIVACY = {
    title: '六六合作伙伴隐私政策',
    date: '本政策仅适用于上海屋聚公共租赁住房运营有限公司的六六找房产品<br>最近更新日期：2023年12月。<br>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：m@zuber.im',
    abstraction: {context: '本隐私政策遵循GB/T 35273-2020《信息安全技术 个人信息保护指南》的标准要求，明确我们App应用程序在处理用户个人信息时的行为规范和保护措施。我们非常重视用户的隐私和数据安全，致力于遵守相关法律法规，保护用户的个人信息不受未经授权的访问和使用。', specifics: [
        '我们将逐一说明我们收集的您的个人信息类型及其对应的用途，以便您了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。',
        '当您使用一些功能时，我们会在获得您的同意后，收集您的一些敏感信息。除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使您无法使用相关特定功能，但不影响您正常使用六六合作伙伴的其他功能。',
        '目前，六六合作伙伴不会主动共享或转让您的个人信息至上海屋聚公共租赁住房运营有限公司外的第三方，如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至上海屋聚公共租赁住房运营有限公司外的第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意，此外，我们会对对外提供信息的行为进行风险评估。'
    ]},
    protocols: [
        {
            name: '我们收集的信息',
            intro: '在您使用六六合作伙伴服务的过程中，六六合作伙伴会按照如下方式收集您在使用服务时主动提供或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的帐号安全：',
            details: [
                { context: '<span class="highlight">当您注册六六合作伙伴帐号时，我们会收集您的昵称、头像、性别、手机号码。收集这些信息是为了帮助您完成六六合作伙伴帐号的注册，保护您的帐号安全。手机号码属于敏感信息，收集此类信息是为了满足相关法律、法规关于网络实名制要求。若您不提供这类信息，您可能无法正常使用我们的服务。您还可以根据自身需求选择填写职业、星座、公司等信息。</span>' },
                { context: '<span class="highlight">当您使用六六找房服务时，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的帐号安全，我们会收集您的设备型号、操作系统、设备Mac地址、唯一设备标识符、设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、六六找房软件版本号、接入网络的方式、类型和状态、操作日志、服务日志信息（如您在阅读功能下的浏览历史、服务故障信息等信息）等日志信息，这类信息是为提供服务必须收集的基础信息。</span>' },
                { context: '<span class="highlight">当您使用六六合作伙伴租房时，六六合作伙伴会在提供房源发布、发送消息、签订合同服务前，要求实名登记，实名登记会获取你的姓名、身份证号、身份证照片、人脸影像等信息，我们会在获得您的明示同意后，访问您的相册、摄像头、麦克风信息。</span>' },
                { context: '<span class="highlight">当您使用六六合作伙伴发消息（包括图片、视频、位置）、拍摄图片或视频时，为了向您提供该服务，我们会在获得您的明示同意后，访问您的相册、麦克风、地理位置信息。</span>' },
                { context: '<span class="highlight">当您使用六六合作伙伴查看房源地理位置，或根据地理位置查找房源时，为了向您提供该服务，我们会在获得您的明示同意后，访问您的地理位置信息。</span>' },
                { context: '另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：<br><br>' , subjects: [
                    '与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；',
                    '与犯罪侦查、起诉、审判和判决执行等直接相关的；',
                    '出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；',
                    '所收集的个人信息是您自行向社会公众公开的；',
                    '从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；',
                    '根据您要求签订和履行合同所必需的；',
                    '用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；',
                    '为开展合法的新闻报道所必需的；',
                    '出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
                    '法律法规规定的其他情形。'
                ]},
                { context: '其他信息收集说明：', subjects: [
                    // '存在定向推送功能，分为私信消息提醒推送服务，点赞,评论个性系统消息定推服务',
                    'app集成魅族推送SDK,该sdk获取SD卡数据用于推送服务',
                    '在业务功能中，存在APP收集ICCID、SD卡数据行为 主要是app集成了腾讯BuglySDK,用于检测并收集设备app异常情况,需要采集设备信息,用于app异常时做兼容适配',
                    '高德sdk获取传感器等信息的行为方便定位获取附近位置信息用于推荐附近房'
                ]}
            ],
            end: '请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。'
        },
        {
            name: '信息的存储',
            details: [
                { subtitle: '信息存储的地点', context: '我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。<br>目前我们不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，我们会向您告知信息出境的目的、接收方、安全保证措施和安全风险，并征得您的同意。'},
                { context: '如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。' }
            ]
        },
        {
            name: '信息安全',
            details: [
                { subtitle: '安全保护措施', context: '我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。<br>我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。此外，我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作，以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。<br>我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。' },
                { subtitle: '安全事件处置措施', context: '若发生个人信息泄露、损毁、丢失等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会及时以推送通知、邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。' }
            ]
        },
        {
            name: '我们如何使用信息',
            intro: '我们严格遵守法律法规的规定以及与用户的约定，按照本隐私政策所述使用收集的信息，以向您提供更为优质的服务。',
            details: [
                { subtitle: '信息使用规则', context: '我们会按照如下规则使用收集的信息：', subjects: [
                    '我们会根据已收集的信息向您提供各项功能与服务，如房源推荐、房源订阅功能；',
                    '为了保证帐号安全，我们会使用您的地理位置信息进行安全检测，以便为您提供更安全的帐号注册服务。'
                ]},
                { subtitle: '告知变动目的后征得同意的方式', context: '我们将会在本隐私政策所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。'}
            ]
        },
        {
            name: '用户权利与行使方式',
            details: [
                { subtitle: '查询权：', context: '用户有权查询其个人信息以及这些信息的具体内容。用户可以通过我们的App进行查询。' },
                { subtitle: '修改权：', context: '如果用户发现其个人信息有误，或者有任何需要更新的信息，他们有权进行修改。同样，用户可以通过我们的App进行修改。' },
                { subtitle: '删除权：', context: '在某些情况下，用户有权删除其个人信息。例如，当信息不再需要用于原先的目的，或者用户撤回同意时。用户可以通过App提出删除请求。' },
                {context: '用户可以按照法律规定更正、删除个人信息及注销用户账号，用户可通过私信联系客服，客服将在24小时内进行处理并在14个工作日内完成账号注销服务。'}
            ]
        },
        {
            name: '对外提供',
            intro: '目前，我们不会主动共享或转让您的个人信息至上海屋聚公共租赁住房运营有限公司外的第三方，如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至上海屋聚公共租赁住房运营有限公司外的第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意。<br>我们不会对外公开披露其收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。<br>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本隐私政策所要求的标准继续保护或要求新的控制者继续保护您的个人信息。<br>另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：',
            details: [
                { subjects: [
                    '与国家安全、国防安全直接相关的；',
                    '与公共安全、公共卫生、重大公共利益直接相关的；',
                    '与犯罪侦查、起诉、审判和判决执行等直接相关的；',
                    '出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
                    '个人信息主体自行向社会公众公开的个人信息；',
                    '从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。'
                ] }
            ]
        },
        {
            name: '第三方工具',
            intro: '在平台或应用开发中，我们会引用/集成第三方的相关功能与SDK并明示使用这些第三方工具的使用目的',
            details: [
                { subjects: [
                    'com.sina.weibo：<br>获取数据：新浪微博<br>使用目的：用于微博登录',
                    'com.huawei.hms：<br>获取数据：IMEI/android ID/OPENUDID/GUID、SIM 卡 IMSI 信息<br>使用目的：用于华为设备通知推送',
                    'com.heytap.msp：<br>获取数据：IMEI/android ID/OPENUDID/GUID、SIM 卡 IMSI 信息<br>使用目的：oppo推送，用于私信通知推送',
                    'com.tencent.bugly：<br>获取数据：IMEI/android ID/OPENUDID/GUID、SIM 卡 IMSI 信息<br>使用目的：app异常信息采集，用于bug追踪',
                    'com.amap.api.location：发布房源定位选择地址<br>获取数据：GPS经纬度信息<br>使用目的：发布房源定位选择地址',
                    'com.alipay.sdk：支付宝sdk，支付佣金<br>获取数据：支付宝授权信息<br>使用目的：支付宝sdk，支付佣金和购买商品',
                    'com.google.android：<br>获取数据：无<br>使用目的：谷歌相关工具包（exoplayer）视频播放器，播放房源视频',
                    'com.xiaomi：<br>获取数据：IMEI/android ID/OPENUDID/GUID、SIM 卡 IMSI 信息<br>使用目的：小米推送，用于私信通知推送',
                    'com.vivo：<br>获取数据：IMEI/android ID/OPENUDID/GUID、SIM 卡 IMSI 信息<br>使用目的：vivo推送，用于私信通知推送',
                    'com.meizu：<br>获取数据：IMEI/android ID/OPENUDID/GUID、SIM 卡 IMSI 信息<br>使用目的：魅族推送，用于私信通知推送',
                    'com.amap.api.maps：<br>获取数据：GPS经纬度信息<br>使用目的：房源定位选择地址在高德地图上显示，房源地址地图显示<br>《高德开放平台隐私权政策》链接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a><br>使用的高德SDK名称、SDK提供方名称（即高德软件有限公司）、收集个人信息的使用目的、高德SDK收集的个人信息。详见《SDK合规使用方案》：<a href="https://lbs.amap.com/agreement/news/sdkhgsy" target="_blank">https://lbs.amap.com/agreement/news/sdkhgsy</a>',
                    'com.qiniu：<br>获取数据：无<br>使用目的：提供图片、视频、文件的云存储服务',
                    '另外其他包：其他类似包均属于第三方开源界面类基础功能类工具包(不涉及到用户隐私）'
                ]}
            ]
        },
        {
            name: '变更',
            intro: '我们可能会适时对本隐私政策进行修订。当隐私政策的条款发生变更时，我们会在您登录及版本更新时以推送通知、弹窗的形式向您展示变更后的隐私政策。请您注意，只有在您点击弹窗中的同意按钮后，我们才会按照更新后的隐私政策收集、使用、存储您的个人信息。'
        },
        {
            name: '与我们联系',
            intro: '当您有其他的投诉、建议相关问题时，请通过六六合作伙伴app与我们联系，或发送邮件到m@zuber.im。<br>我们将尽快审核所涉问题，并在验证您的用户身份后的十五天内予以回复。'
        }
    ]
}